module.exports = __webpack_public_path__ + "static/media/banner_home_03.46009e55.png";